export const DATE_FORMAT_USA_SHORT = 'MM/DD/YYYY';
export const DATE_FORMAT_SHORT = 'YYYY-MM-DD';
export const DATE_FORMAT_LONG = 'YYYY-MM-DDTHH:mm:ss';
export const FNS_DATE_FORMAT_LONG = `yyyy-MM-dd'T'HH:mm:ss`;
